module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"BBF":"Bai Brun Fonce","BB":"Bai Brun","BF":"Bai Fonce","B":"Bai","AUB":"Aubere","AF":"Alezan Fonce","AL":"Alezan","NME":"Noir Melange","NP":"Noir Pangare","xx":"Inconnue","RO":"Rouan","N":"Noir","GRR":"Gris Rouanne","GRF":"Gris Fonce","GR":"Gris"}}')
  delete Component.options._Ctor
}
